/**
 *  AenaTerminalSelector script file
**/
import { AenaTerminalsAccordion } from './aena-terminals-accordion'
import { mapGetters, mapActions } from 'vuex'
import { GETTERS, ACTIONS } from '@/store'
import capitalize from '@/filters/capitalize'
import { normalizeLowerCase } from '@/utils/matchString'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'

export default {
  name: 'app-aenaTerminalSelector',
  mixins: [capitalize, setDeviceWidthClass],
  components: {
    AenaTerminalsAccordion
  },
  props: {},
  data () {
    return {
      selected: undefined,
      floor: undefined,
      type: 'terminals',
      open: false
    }
  },
  created () {
    this.initData()
  },
  computed: {
    ...mapGetters({
      isMobile: GETTERS.GET_IS_MOBILE,
      buildings: GETTERS.GET_BUILDINGS,
      building: GETTERS.GET_BUILDING,
      floorC: GETTERS.GET_FLOOR,
      airportID: GETTERS.GET_AIRPORT_ID
    }),
    accordionData () {
      const terminals = {
        id: '1',
        title: 'terminales',
        items: this.buildings.filter(x => x.category === 'TERMINAL')
      }
      const parkings = {
        id: '2',
        title: 'parkings',
        items: this.buildings.filter(x => x.category !== 'TERMINAL')
      }

      return {
        terminals,
        parkings
      }
    },
    active () {
      return (this.selected || {}).name
    }
  },
  methods: {
    ...mapActions([
      ACTIONS.LOAD_FLOOR,
      ACTIONS.LOAD_VIEW,
      ACTIONS.RESET_BBOX
    ]),
    initData () {
      this.type = 'terminals'
      this.selected = this.building
      if (this.building) {
        this.type = this.building.category === 'TERMINAL' ? 'terminals' : 'parkings'
      }
      this.floor = this.floorC
      this.updateScrolls()
    },
    clear () {
      const bbox = this.selected
      this.selected = null
      this.floor = null

      this[ACTIONS.LOAD_FLOOR]({
        floor: this.floor,
        building: this.selected
      })

      this[ACTIONS.RESET_BBOX](bbox)

      this.closeDropdown()
    },
    closeDropdown () {
      this.$refs.accordion.activeSubItem = undefined
      this.$refs.dropdown.open = false
    },
    onItemSelected (item) {
      this.selected = item
      this.floor = undefined

      const tag = {
        'eventCategory': 'explorador',
        'eventAction': 'clic',
        'eventLabel': normalizeLowerCase(item.name),
        'language': this.$i18n.locale,
        'airportID': this.airportID
      }
      window.digitalChange('event', tag)

      this.$nextTick(() => {
        this.updateScrolls()
        this.$refs.floors.focus()
      })
    },
    onToggle (item) {
      this.type = item
      this.selected = undefined
      this.floor = undefined
    },
    onDropdownToggle () {
      this.initData()
      this.updateScrolls()
    },
    updateScrolls () {
      setTimeout(() => {
        this.$refs.accordion.$refs.scrollbar.update()
        this.$refs.scrollbar.update()
      }, 360)
    },
    onSelectFloor (floor) {
      this.floor = floor
      this[ACTIONS.LOAD_FLOOR]({
        floor: this.floor,
        building: this.selected
      })

      const label = `${this.selected.name}. Planta ${floor.name}`
      const tag = {
        'eventCategory': 'explorador',
        'eventAction': 'clic',
        'eventLabel': `${normalizeLowerCase(label)}`,
        'language': this.$i18n.locale,
        'airportID': this.airportID
      }
      window.digitalChange('event', tag)

      this[ACTIONS.LOAD_VIEW]('aena-highlighted-points')
      this.$refs.dropdown.$refs.button.focus()

      if (this.isMobile) {
        this.$refs.dropdown.open = false
      }
    }
  },
  watch: {
    building (value) {
      this.selected = value
    },
    floorC (value) {
      this.floor = value
    }
  }
}
